import type { FC } from 'react';
import { useState } from 'react';
import { Tab, Tabs, Container } from 'react-bootstrap';
import TimesheetTab from '../components/timesheet/TimesheetTab';
import ReportsTab from '../components/reports/ReportsTab';
import Layout from '@components/Layout';

const PortalPage: FC = () => {
  const [activeTab, setActiveTab] = useState<string>('timesheet');

  return (
    <Layout>
      <Container fluid className="mt-5 pt-3">
      <Tabs
        id="portal-tabs"
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k || 'timesheet')}
        className="mb-3"
      >
        <Tab eventKey="timesheet" title="Timesheet">
          <TimesheetTab />
        </Tab>

        <Tab eventKey="expense" title="Expense">
          <div className="p-4">
            <h3>Expense Tracking</h3>
            <p>Expense functionality will be added here</p>
          </div>
        </Tab>

        <Tab eventKey="reports" title="Reports">
          <ReportsTab />
        </Tab>

        <Tab eventKey="links" title="Links">
          <div className="p-4">
            <h3>Useful Links</h3>
            <p>Links will be added here</p>
          </div>
        </Tab>
      </Tabs>
      </Container>
    </Layout>
  );
};

export default PortalPage;
